import React from "react";
import { Box, Typography } from "@mui/material";
import { BrowserView, MobileView } from "react-device-detect";
import { useTheme } from "@emotion/react";
import NotificationPopup from "./NotificationPopup.js";

const UploadingPopup = ({ open, message, icon }) => {
  const theme = useTheme();

  return (
    <>
      <BrowserView>
        <NotificationPopup open={open} title="Notification" message={message} iconSrc={icon} variant={"secondary"} />
      </BrowserView>
      <MobileView>
        {open && (
          <Box
            sx={{
              position: "fixed",
              width: "90vw",
              left: "5vw",
              bottom: 15,
              borderRadius: "10px",
              backgroundColor: theme.palette.secondary.main,
              display: "flex",
              alignItems: "center",
              gap: 1,
              zIndex: 9999,
              px: 1,
              py: 0.5,
            }}
          >
            <img src="assets/icons/uploadcloud.svg" alt="uploadcloud"></img>
            <Typography color="white" fontSize={20}>
              {message}
            </Typography>
          </Box>
        )}
      </MobileView>
    </>
  );
};

export default UploadingPopup;
